import { createCustomEnum } from "../customEnum";

export type BoardingOutcomeTypes =
	| "successful_boarding"
	| "duplicate"
	| "client_disappeared";

export const BoardingOutcomeEnum = createCustomEnum({
	SuccessfulBoarding: {
		value: 0,
		name: "successful_boarding",
		displayName: "Successful Boarding",
	},
	Duplicate: {
		value: 1,
		name: "duplicate",
		displayName: "Duplicate",
	},
	ClientDisappeared: {
		value: 2,
		name: "client_disappeared",
		displayName: "Client Disappeared",
	},
	Rejected: {
		value: 3,
		name: "rejected",
		displayName: "Rejected",
	},
});

export const BoardingCompleteOutcomes = [
	BoardingOutcomeEnum.SuccessfulBoarding,
	BoardingOutcomeEnum.Duplicate,
	BoardingOutcomeEnum.ClientDisappeared,
];
